import script from "./MyQuestionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyQuestionsView.vue?vue&type=script&setup=true&lang=ts"

import "./MyQuestionsView.vue?vue&type=style&index=0&id=c85eac34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c85eac34"]])

export default __exports__